import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

const MsalRedirectHandler = ({ children }) => {
  const { instance } = useMsal();

  useEffect(() => {
    instance.handleRedirectPromise().then((response) => {
      if (response) {
        // Authentication successful, you might want to log this or update global state
        console.log('Redirect promise resolved successfully', response);
      }
    }).catch((error) => {
      console.error('Redirect promise failed', error);
      // Handle errors from redirect (e.g., show an error message to the user)
    });
  }, [instance]); // Depend on instance to ensure it's available

  return <>{children}</>;
};

export default MsalRedirectHandler;
